
import { mapActions, mapState, mapGetters } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
import MenuCreateAddon from "../menu/menu-create-addon.vue";
export default {
  components: { ResponsiveDialog, MenuCreateAddon },
  props: {
    dialog: false,
    addonProp: {
      default: Object
    }
  }
};
